import { Component, OnInit } from '@angular/core';
import {PartnerWalletService} from '../../../partner-wallet.service';
import {AppUserPartnerWalletAccessSlim} from '../../../dto/app-user-partner-wallet-access-slim';

@Component({
  selector: 'app-pending-invites',
  templateUrl: './pending-invites.component.html',
  styleUrls: ['./pending-invites.component.css']
})
export class PendingInvitesComponent implements OnInit {

  public pendingInvites: AppUserPartnerWalletAccessSlim[] = [];
  public incompleteInvites: AppUserPartnerWalletAccessSlim[] = [];
  public finishedInvites: AppUserPartnerWalletAccessSlim[] = [];
  displayedColumns: string[] = ['id', 'wallet', 'company', 'director', 'view'];
  isLoadingIncomplete = false;
  isLoadingPending = false;
  isLoadingFinished = false;

  constructor(
    private partnerWalletService: PartnerWalletService
  ) { }

  ngOnInit(): void {
    this.isLoadingPending = true;
    this.partnerWalletService.getPendingInvites().subscribe(invites => {
      this.pendingInvites = invites;
      this.isLoadingPending = false;
    }, err => {
      this.isLoadingPending = false;
    });

    this.isLoadingIncomplete = true;
    this.partnerWalletService.getIncompleteInvites().subscribe(invites => {
      this.incompleteInvites = invites;
      this.isLoadingIncomplete = false;
    }, err => {
      this.isLoadingIncomplete = false;
    });

    this.isLoadingFinished = true;
    this.partnerWalletService.getFinishedInvites().subscribe(invites => {
      this.finishedInvites = invites;
      this.isLoadingFinished = false;
    }, err => {
      this.isLoadingFinished = false;
    });


  }

}
